import {
    bexHttpClient
} from '../../clients';
import {
    CreateCollectionRequest,
    UpdateCollectionRequest,
    DeleteCollectionRequest,
    CreateCollectionResponse,
    UpdateCollectionResponse,
    DeleteCollectionResponse,
    ListCollectionsResponse
} from '../bexService.types';

/**
 * Service class for performing redis collection operations.
 */
class RedisCollectionService {

    /**
     * Fetches the sub organization collections.
     * @param {string} organizationId - The organization ID.
     * @param {string} subOrganizationId - The sub-organization ID.
     * @returns {Promise<ListCollectionsResponse>} The response from the server returns sub organization collections.
     */
    async listCollections(organizationId: string, subOrganizationId: string, page?: number, limit?: number): Promise<ListCollectionsResponse> {
        let url = `/redis/collections/list-collections?organizationId=${organizationId}&subOrganizationId=${subOrganizationId}`;
        if (page !== undefined) url += `&page=${page}`;
        if (limit !== undefined) url += `&limit=${limit}`;
        const response = await bexHttpClient.get(url);
        return response;
    }

    /**
     * add new collection.
     * @param {CreateCollectionRequest} data - The new collection data including name, organizationId, subOrganizationId and projectId.
     * @returns {Promise<CreateCollectionResponse>} The response from the server returns new collection document from mongoDB.
     */
    async addCollection(data: CreateCollectionRequest): Promise<CreateCollectionResponse> {
        const response = await bexHttpClient.post('/redis/collections/add-collection', data);
        return response;
    }

    /**
     * update collection.
     * @param {UpdateCollectionRequest} data - The updated collection data including organizationId, subOrganizationId, projectId, collectionId, name and assistants.
     * @returns {Promise<UpdateCollectionResponse>} The response from the server returns updated collection document from mongoDB.
     */
    async updateCollection(data: UpdateCollectionRequest): Promise<UpdateCollectionResponse> {
        const response = await bexHttpClient.put('/redis/collections/update-collection', data);
        return response;
    }

    /**
     * delete collection.
     * @param {DeleteCollectionRequest} data - Delete collection data including collectionId, organizationId, subOrganizationId and projectId.
     * @returns {Promise<DeleteCollectionResponse>} The response from the server returns deletion status.
     */
    async deleteCollection(data: DeleteCollectionRequest): Promise<DeleteCollectionResponse> {
        const response = await bexHttpClient.delete('/redis/collections/delete-collection', {
            data: data
        });
        return response;
    }

}

const redisCollectionService = new RedisCollectionService();
export { redisCollectionService };